import React, {useState, useEffect} from 'react'
import Api from '../servicios/api'
import {Header, Titulo, ContenedorHeader} from '../elementos/Header'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'
import VentanaModalText from '../elementos/VentanaModalText'
import {useAuth} from "./../contextos/AuthContext"
import {ContenedorBotonesLista, BotonEliminarTrash, BotonAprobar, BotonRechazar} from '../elementos/ElementosDeLista'
import { FaTrashAlt, FaRegThumbsDown, FaRegThumbsUp } from "react-icons/fa";

const ListaSolicitudesVisita = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [solicitudes, setSolicitudes] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modal, setModal] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [modalText, setModalText] = useState({});
    const [estadoModalText, setEstadoModalText] = useState(false);
    const [textAreaMotivo, setTextAreaMotivo] = useState("");
    const {idUsuario} = useAuth();
    const [parametro, setParametro] = useState();
    const [idSolicitudVisita, setIDSolicitudVisita] = useState();
    const [fecha, setFecha] = useState();
    const [hora, setHora] = useState();
    const [correo, setCorreo] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(Api+"?consultarSolicitudes")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true)
            setSolicitudes(datosRespuesta)
        })
        .catch(console.log)
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'textAreaMotivo':
                setTextAreaMotivo(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleActualizar = (id, fecha, hora, correo, parametro) => {
        setIDSolicitudVisita(id);
        setFecha(fecha);
        setHora(hora);
        setCorreo(correo);
        setParametro(parametro);
        
        if(parametro === 1){
            setEstadoModal(true);
            setModal({
                header: 'Aprobar Solicitud',
                body: '¿Está seguro de aprobar la solicitud?'
            });
        }

        else if(parametro === 2){
            setEstadoModalText(true)
            setModalText({
                header: 'Rechazar Solicitud',
                body: 'Motivo del rechazo'
            });
        }

        else{
            setEstadoModal(true);
            setModal({
                header: 'Eliminar Solicitud',
                body: '¿Está seguro de eliminar la solicitud?'
            });
        }
    }

    const actualizarSolicitud = () => {
        setEstadoModal(false);
        setEstadoModalText(false);
        setEstadoAlerta(false);
        setAlerta({});

        var datosEnviar = {id:idSolicitudVisita, fecha:fecha, hora:hora, correo:correo, idUsuario:idUsuario, motivo:textAreaMotivo, param:parametro}
        fetch(Api+"?actualizarSolicitud",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.tipo === 'aprobar'){
                if(datosRespuesta.success === 1){
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: datosRespuesta.mensaje
                    });
                }
                else if(datosRespuesta.success === 2){
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: datosRespuesta.mensaje
                    });
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: datosRespuesta.mensaje
                    });
                }
            }

            else if(datosRespuesta.tipo === 'eliminar'){
                if(datosRespuesta.success === 1){
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: datosRespuesta.mensaje
                    });
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: datosRespuesta.mensaje
                    });
                }
            }
            
            else{
                if(datosRespuesta.success === 1){
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: datosRespuesta.mensaje
                    });
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: datosRespuesta.mensaje
                    });
                }
            }

            cargarDatos();
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }

    else{
        return (
            <>
                <VentanaModal />
                <Header>
                    <ContenedorHeader>
                        <Titulo>Solicitudes de visitas</Titulo>
                    </ContenedorHeader>
                </Header>

                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha Visita</th>
                                        <th>Hora Visita</th>
                                        <th>Insitución</th>
                                        <th>Teléfono</th>
                                        <th>Correo</th>
                                        <th>Objetivo de Visita</th>
                                        <th># de Visitantes</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        solicitudes.success !== 0 &&
                                            solicitudes.map(
                                                (solicitud)=>(
                                                    <tr key={solicitud.SV_ID}>
                                                        <td>{solicitud.SV_Fecha}</td>
                                                        <td>{solicitud.SV_Hora}</td>
                                                        <td>{solicitud.SV_Institucion}</td>
                                                        <td>{solicitud.SV_Telefono}</td>
                                                        <td>{solicitud.SV_Correo}</td>
                                                        <td>{solicitud.SV_Comentario}</td>
                                                        <td>{solicitud.SV_NumVisitantes}</td>
                                                        <td>
                                                            

                                                            <ContenedorBotonesLista>
                                                                <BotonAprobar title="Aprobar Solicitud" 
                                                                onClick={()=> handleActualizar(solicitud.SV_ID, solicitud.SV_Fecha, solicitud.SV_Hora, solicitud.SV_Correo, 1)}
                                                                ><FaRegThumbsUp />
                                                                </BotonAprobar>
                                                                
                                                                <BotonRechazar title="Rechazar Solicitud" 
                                                                onClick={()=> handleActualizar(solicitud.SV_ID, solicitud.SV_Fecha, solicitud.SV_Hora, solicitud.SV_Correo, 2)}
                                                                ><FaRegThumbsDown />
                                                                </BotonRechazar>

                                                                <BotonEliminarTrash title="Eliminar Solicitud" 
                                                                onClick={()=> handleActualizar(solicitud.SV_ID, solicitud.SV_Fecha, solicitud.SV_Hora, solicitud.SV_Correo, 3)}
                                                                ><FaTrashAlt />
                                                                </BotonEliminarTrash>
                                                            </ContenedorBotonesLista>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader={modal.header}
                        mensajeBody={modal.body}
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={actualizarSolicitud}
                />

                <VentanaModalText
                        textAreaMotivo={textAreaMotivo}
                        handleChange={handleChange}
                        mensajeHeader={modalText.header}
                        mensajeBody={modalText.body}
                        estadoModalText={estadoModalText}
                        setEstadoModalText={setEstadoModalText}
                        handleConfirm={actualizarSolicitud}
                />  
            </>
        );
    }
}
 
export default ListaSolicitudesVisita;